import { gql } from '@apollo/client'

export const CORE_FEED_FIELDS = gql`
    fragment CoreFeedFields on Feed {
        id
        title
        text
        media
        url
        sentiment
        postedAt
        profile {
            id
            username
            name
            description
            imageUrl
            url
            joinedAt
        }
    }
`

export const GET_FEEDS = gql`
    ${CORE_FEED_FIELDS}
    query Feeds($where: FeedWhere, $options: FeedOptions) {
        feeds(where: $where, options: $options) {
            ...CoreFeedFields
            comments {
                ...CoreFeedFields
            }
            keywords {
                id
                value
            }
        }
    }
`

// Used by SocialFeed and Communities pages for platform filter options
export const GET_FEED_PLATFORMS = gql`
    query Platforms($options: PlatformOptions, $where: PlatformWhere) {
        platforms(options: $options, where: $where) {
            id
            name
            type
        }
    }
`

// Used by SocialFeed and Communities pages for keyword filter options
export const GET_FEED_CAMPAIGN_KEYWORDS = gql`
    query Campaigns($where: CampaignWhere) {
        campaigns(where: $where) {
            keywords
        }
    }
`

// Used by Communities page for category dropdown
export const GET_FEED_CATEGORIES = gql`
    query Categories($where: CategoryWhere) {
        categories(where: $where) {
            id
            name
        }
    }
`

// Used by ClassificationReport for category audience data
export const GET_REPORT_CATEGORIES = gql`
    query Categories($where: CategoryWhere) {
        categories(where: $where) {
            id
            name
            audience
            ratio
        }
    }
`

// Used by ClassificationReport to get campaign categories
export const GET_CAMPAIGN_CATEGORIES = gql`
    query Campaigns($where: CampaignWhere) {
        campaigns(where: $where) {
            categories
        }
    }
`

// Used by SentimentAnalysisChart (time-series)
export const GET_SENTIMENT_BY_PERIOD = gql`
    query Campaigns($where: CampaignWhere) {
        campaigns(where: $where) {
            sentimentThisWeek {
                positive
                neutral
                negative
            }
            sentimentThisMonth {
                positive
                neutral
                negative
            }
            sentimentThisYear {
                positive
                neutral
                negative
            }
        }
    }
`

// Used by SentimentAnalysisPieChart (overall totals)
export const GET_SENTIMENT = gql`
    query Campaigns($where: CampaignWhere) {
        campaigns(where: $where) {
            sentiment
        }
    }
`

export const GET_SUMMARY = gql`
    query Campaigns($where: CampaignWhere) {
        campaigns(where: $where) {
            name
            audienceProfile
        }
    }
`

export const GET_SUMMARISATION = gql`
    query Campaigns($where: CampaignWhere) {
        campaigns(where: $where) {
            name
            summary
            lastSummarisedAt
        }
    }
`

export const GET_EXTRACTION_HEADERS = gql`
    query Campaigns($where: CampaignWhere) {
        campaigns(where: $where) {
            headers
            subheaders
            descriptions
            lastExtractedAt
        }
    }
`

export const GET_LEADS = gql`
    query Leads($where: LeadWhere, $options: LeadOptions) {
        leads(where: $where, options: $options) {
            id
            fields
            createdAt
        }
    }
`

export const GET_LEAD_LANDING_PAGES = gql`
    query LandingPages($where: LandingPageWhere) {
        landingPages(where: $where) {
            id
            title
        }
    }
`

// More complete version of GET_INSIGHTS used by CampaignAnalytics page
export const GET_PUBLISHER_INSIGHTS = gql`
    query Publishers(
        $publishersWhere: PublisherWhere
        $adCampaignsWhere: AdCampaignWhere
        $options: AdCampaignOptions
    ) {
        publishers(where: $publishersWhere) {
            name
            adCampaigns(where: $adCampaignsWhere, options: $options) {
                addToCart
                addToCartValue
                conversion
                conversionsByMonths
                costPerConversion
                updatedAt
                engagement
                impressions
                uniqueCtr
                publishers
                purchase
                purchaseValue
                reach
                spend
                createdAt
                landingPagesConnection {
                    edges {
                        sales
                        conversionRate
                        node {
                            id
                        }
                    }
                }
            }
        }
    }
`

export const GET_PUBLISHER_CUSTOM_INSIGHTS = gql`
    query PublisherCustomInsights($from: DateTime!, $to: DateTime!) {
        publisherCustomInsights(from: $from, to: $to) {
            id
            name
            addToCart
            addToCartValue
            conversion
            costPerConversion
            engagement
            impressions
            uniqueCtr
            publishers
            purchase
            purchaseValue
            reach
            spend
        }
    }
`

export const DELETE_FEED = gql`
    mutation DeleteFeed($feedId: ID!) {
        deleteFeed(feedId: $feedId) {
            id
        }
    }
`
